const section1 = "sections/section1.png";
const section2 = "sections/section2.png";
const section3 = "sections/section3.png";
const section4 = "sections/section4.png";
const section5 = "sections/section5.png";

export const content = [
  {
    image: section1,
    position: "left",
    heading: "Revolutionizing Software Testing with AI and ML",
    info: "At GAINSS, we bring the power of artificial intelligence (AI) and machine learning (ML) to the heart of software testing.",
    lists: [
      {
        heading: "Smarter Test Case Design",
        info: "Get AI-driven recommendations to design impactful and efficient test cases based on requirements, user stories, and feature changes in upcoming releases.",
      },
      {
        heading: "Execution Suite Optimization",
        info: "Automatically build and prioritize execution suites tailored to specific user stories, risk areas, and release features.",
      },
      {
        heading: "Execution Matrix Recommendations",
        info: "Plan and create test execution matrices effortlessly, optimized for devices, operating systems, browsers, and localization needs.",
      },
    ],
  },
  {
    image: section2,
    position: "right",
    heading: "Unmatched Planning and Execution Capabilities",
    info: "GAINSS is built to support your end-to-end testing lifecycle with precision and scalability.",
    lists: [
      {
        heading: "Integrated Dashboards and Metrics",
        info: "Real-time insights into test coverage, execution progress, defect density, and more, all in one place.",
      },
      {
        heading: "Streamlined Localization Testing",
        info: "Simplify planning and execution for global releases with tools to manage test coverage for multiple languages, locales, and regions.",
      },
      {
        heading: "Real-Time Updates with Automation",
        info: "Seamlessly integrate your test automation frameworks using GAINSS-provided APIs to update execution results in real time.",
      },
    ],
  },
  {
    image: section3,
    position: "left",
    heading: "Empowering Faster Defect Analysis and Collaboration",
    info: "GAINSS reduces time-to-resolution and fosters collaboration across teams with built-in intelligent features.",
    lists: [
      {
        heading: "Defect Auto-Association",
        info: "Automatically detect and attach defects logged against failed test cases, significantly reducing failure analysis time.",
      },
      {
        heading: "Actionable Failure Insights",
        info: "Generate detailed defect logs with links to related test cases and user stories, ensuring quick and effective triaging.",
      },
      {
        heading: "Team Collaboration",
        info: "Enable testers, developers, and managers to collaborate seamlessly using shared dashboards and traceability from requirements to defects.",
      },
    ],
  },
  {
    image: section4,
    position: "right",
    heading: "Designed for Engineering Leaders and Testing Teams",
    info: "Whether you're an engineering leader seeking better ROI or a test manager striving for operational excellence, GAINSS has you covered.",
    lists: [
      {
        heading: "Improve Release Predictability",
        info: "Gain data-driven insights to enhance release planning and execution.",
      },
      {
        heading: "Achieve Better Test Coverage",
        info: "Automate planning and execution matrix design to maximize test efficiency.",
      },
      {
        heading: "End-to-End Traceability",
        info: "Integrated dashboards provide seamless tracking from requirements to defects.",
      },
      {
        heading: "Faster Defect Resolution",
        info: "Leverage auto-association and actionable insights to speed up defect resolution.",
      },
    ],
  },
  {
    image: section5,
    position: "left",
    heading: "Features That Redefine Test Management",
    info: "Discover the key features that make GAINSS the ultimate test management tool.",
    lists: [
      {
        heading: "AI-Powered Recommendations",
        info: "Intelligent suggestions for test case design and execution planning.",
      },
      {
        heading: "Advanced Reporting Dashboards",
        info: "Real-time data for test execution, defect trends, and quality metrics.",
      },
      {
        heading: "Automation-First Approach",
        info: "API-driven integrations with your favorite automation frameworks for instant result updates.",
      },
      {
        heading: "Localization Support",
        info: "Simplified planning and execution for multi-language and region-specific testing.",
      },
      {
        heading: "Device, OS, and Browser Matrix",
        info: "Plan and execute across diverse configurations effortlessly.",
      },
      {
        heading: "Defect Auto-Association",
        info: "Shorten failure analysis with defects auto-linked to test cases.",
      },
    ],
  },
];
